module.exports = __webpack_public_path__ + "f68d0aa4de99720b6a5d05491cba46ae.MP3";